import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";

function Review() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [rating, setRating] = useState("");
  const [comment, setComment] = useState("");
  const [looks, setLooks] = useState("");
  const [attitude, setAttitude] = useState("");
  const [value, setValue] = useState("");
  const [charCount, setCharCount] = useState(0);
  const [message, setMessage] = useState("");

  // Get user info from cookie
  const userCookie = Cookies.get("user");
  const user = userCookie ? JSON.parse(userCookie) : null;
  const userEmail = user ? user.email : null;

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!userEmail) {
      setMessage("❌ You must be logged in to leave a review.");
      return;
    }

    const reviewData = {
      user_email: userEmail, // send email instead of userId
      rating,
      comment,
      looks,
      attitude,
      value,
    };

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/review/${id}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(reviewData),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "Failed to submit review.");
      }

      setMessage("✅ Review submitted successfully!");
      setRating("");
      setComment("");
      setLooks("");
      setAttitude("");
      setValue("");
      setCharCount(0);

      // Redirect to home after 1 second
      setTimeout(() => {
        navigate("/");
      }, 1000);

    } catch (error) {
      setMessage(`❌ ${error.message}`);
    }
  };

  return (
    <div
      style={{
        background: "#ffffff",
        maxWidth: "700px",
        margin: "30px auto",
        padding: "30px",
        borderRadius: "10px",
        border: "2px solid #1976d2",
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        fontFamily: "Arial, sans-serif",
        color: "#0d47a1",
      }}
    >
      <h2 style={{ marginBottom: "20px", color: "#1a237e", fontWeight: 600 }}>
        Leave a Review 
      </h2>

      {/* Show logged-in user email */}
      {userEmail && (
        <div
          style={{
            marginBottom: "20px",
            padding: "10px",
            backgroundColor: "#e3f2fd",
            borderRadius: "6px",
            fontSize: "14px",
          }}
        >
          Logged in as: <strong>{userEmail}</strong>
        </div>
      )}

      <form onSubmit={handleSubmit}>
        {/* Rating */}
        <div style={{ marginBottom: "15px" }}>
          <label><strong>Rating (0–10):</strong></label><br />
          <select
            value={rating}
            onChange={(e) => setRating(e.target.value)}
            required
            style={selectStyle}
          >
            <option value="">Select</option>
            {[...Array(11).keys()].map((n) => (
              <option key={n} value={n}>{n}</option>
            ))}
          </select>
        </div>

        {/* Comment */}
        <div style={{ marginBottom: "15px" }}>
          <label><strong>Comment (max 2000 characters):</strong></label><br />
          <textarea
            value={comment}
            onChange={(e) => {
              const text = e.target.value.slice(0, 2000);
              setComment(text);
              setCharCount(text.length);
            }}
            rows="5"
            required
            style={{
              width: "100%",
              padding: "10px",
              border: "1px solid #ccc",
              borderRadius: "6px",
              fontSize: "14px",
              resize: "vertical",
            }}
          />
          <div style={{ textAlign: "right", fontSize: "12px", color: "#444" }}>
            {charCount}/2000
          </div>
        </div>

        {/* Looks */}
        <div style={{ marginBottom: "15px" }}>
          <label><strong>Looks (0–10):</strong></label><br />
          <select
            value={looks}
            onChange={(e) => setLooks(e.target.value)}
            required
            style={selectStyle}
          >
            <option value="">Select</option>
            {[...Array(11).keys()].map((n) => (
              <option key={n} value={n}>{n}</option>
            ))}
          </select>
        </div>

        {/* Attitude */}
        <div style={{ marginBottom: "15px" }}>
          <label><strong>Attitude:</strong></label><br />
          <select
            value={attitude}
            onChange={(e) => setAttitude(e.target.value)}
            required
            style={selectStyle}
          >
            <option value="">Select</option>
            {["Very Bad", "Bad", "Average", "Good", "Very Good", "Amazing"].map((opt) => (
              <option key={opt} value={opt}>{opt}</option>
            ))}
          </select>
        </div>

        {/* Value */}
        <div style={{ marginBottom: "20px" }}>
          <label><strong>Value (1–10):</strong></label><br />
          <select
            value={value}
            onChange={(e) => setValue(e.target.value)}
            required
            style={selectStyle}
          >
            <option value="">Select</option>
            {[...Array(10).keys()].map((n) => (
              <option key={n + 1} value={n + 1}>{n + 1}</option>
            ))}
          </select>
        </div>

        {/* Submit */}
        <button
          type="submit"
          style={{
            backgroundColor: "#1976d2",
            color: "#fff",
            border: "none",
            padding: "10px 20px",
            borderRadius: "6px",
            fontSize: "16px",
            fontWeight: "bold",
            cursor: "pointer",
            transition: "background 0.3s",
          }}
          onMouseEnter={(e) => e.target.style.background = "#115293"}
          onMouseLeave={(e) => e.target.style.background = "#1976d2"}
        >
          Submit Review
        </button>

        {/* Message */}
        {message && (
          <div
            style={{
              marginTop: "20px",
              color: message.startsWith("✅") ? "green" : "red",
              fontWeight: "bold",
            }}
          >
            {message}
          </div>
        )}
      </form>
    </div>
  );
}

// Shared select styling
const selectStyle = {
  width: "100%",
  padding: "8px",
  borderRadius: "6px",
  border: "1px solid #ccc",
  fontSize: "14px",
};

export default Review;
